import React from 'react';
import ReadCookie from '../../functions/readcookies';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import Branch from '../../functions/branch';
import Drawer from '../drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

class BranchControl extends React.Component {

  state = {
    load: false,
    allbranch: [],
    morebranch: false
  }

  componentDidMount() {
    this.checkCookies();
  }

  componentDidUpdate(props) {
    if (props.number != this.props.number) {
      this.checkCookies();
    }
  }

  checkCookies() {
    let cook = (ReadCookie("branch"));
    if (cook == null) {
      this.setState({
        allow: false
      })
      this.getBranch();
    }
    else {
      this.setState({
        allow: true
      })
    }
  }

  getBranch() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let data1 = { 'userId': userId };
    this.setState({
      load: true,
      message: 'Getting Branch!!!!',
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'executivebranch/getbranch.php',
      success: function(data) {
        let data1;
        context.setState({
          load: false,
        });
        try {
          data1 = JSON.parse(data);
          if (data1.length == 1) {
            context.setCookie(data);
          }
          else if (data1 == 0) {
            context.setCookiesWithZeroValue();
          }
          else {
            context.setState({
              allbranch: data1,
              morebranch: true
            });
          }
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setCookiesWithZeroValue() {
    let data = 0;
    this.createCookie('branch', data, 7);
  }

  setCookie(data) {
    this.createCookie('branch', data, 7);
  }

  createCookie(name,value,days) {
    value = JSON.stringify(value);
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + ";path=/";
    this.checkCookies();
  }

  selectBranch(id) {
    let items = [];
    let data = this.state.allbranch;
    data.map((z) =>{
      if (z.id == id) {
        items.push(z);
      }
    });
    items = JSON.stringify(items);
    this.setCookie(items);
  }

  render() {
    let out = (<div></div>);
    if (this.state.morebranch) {
      out = (
        <div>
          <Dialog open={this.state.morebranch} onClose={this.handleClose} aria-labelledby="simple-dialog-title">
            <DialogTitle id="simple-dialog-title" style={{width: 300}}>Select Branch</DialogTitle>
            <div>
              <List>
              { this.state.allbranch.map((z) => {
                  return(
                    <div style={{paddingLeft: '5%', cursor: 'pointer'}}>
                      <ListItem style={{fontSize: 14}} onClick={this.selectBranch.bind(this, z.id)}><b>{z.name}</b></ListItem>
                    </div>
                  )
                })
              }
              </List>
            </div>
          </Dialog>
        </div>
      )
    }
    return (
      <div>
        {this.state.allow ? (<div></div>) : (<div>{out}</div>)}
      </div>
    );
  }
}

export default BranchControl;
